import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const modal = document.getElementById('delete-modal');
    const openModalBtn = document.getElementById('open-delete-modal');
    const cancelBtn = document.getElementById('cancel-delete');

    if (openModalBtn) {
      openModalBtn.addEventListener('click', (event) => {
        event.preventDefault();
        modal.classList.remove('hidden');
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', (event) => {
        event.preventDefault();
        modal.classList.add('hidden');
      });
    }
  }
} 